import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6f8deab8")

_pushScopeId("data-v-6f8deab8")
const _hoisted_1 = { class: "filters" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OCalendar = _resolveComponent("OCalendar")
  const _component_SelectFish = _resolveComponent("SelectFish")
  const _component_SelectPond = _resolveComponent("SelectPond")
  const _component_OButton = _resolveComponent("OButton")
  const _component_ODialog = _resolveComponent("ODialog")

  return (_openBlock(), _createBlock(_component_ODialog, {
    visible: _ctx.visibleComputed,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.visibleComputed = $event)),
    header: "Filtros",
    "dismissable-mask": ""
  }, {
    footer: _withId(() => [
      _createVNode(_component_OButton, {
        label: "Limpar",
        icon: "pi pi-filter-slash",
        class: "p-button-text",
        onClick: _ctx.handleClear
      }, null, 8, ["onClick"]),
      _createVNode(_component_OButton, {
        label: "Aplicar",
        "data-test": "applyFilter",
        onClick: _ctx.handleApply
      }, null, 8, ["onClick"])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_OCalendar, {
          modelValue: _ctx.filtersLocal.date,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filtersLocal.date = $event)),
          "manual-input": false,
          placeholder: "Data",
          "show-icon": "",
          "touch-u-i": "",
          "show-button-bar": ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_SelectFish, {
          modelValue: _ctx.filtersLocal.fishOrId,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filtersLocal.fishOrId = $event)),
          "show-inactive": "",
          "data-test": "fish"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_SelectPond, {
          modelValue: _ctx.filtersLocal.pondOrId,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filtersLocal.pondOrId = $event)),
          modelModifiers: { number: true },
          "show-inactive": "",
          "data-test": "pond"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
})